import {Component, OnDestroy, OnInit, NgZone} from '@angular/core';
import {AppClipsInterface} from '../interfaces/app-clips.interface';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {ApiService} from '../service/api.service';
import {Router} from '@angular/router';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels} from '@techiediaries/ngx-qrcode';
import {NotifierService} from 'angular-notifier';

declare const showEmbed: any;
declare const branch: any;

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.sass']
})
export class LandingPageComponent implements OnInit, OnDestroy {

  public modal = false;
  public errorModal = false;
  public token = null;
  public disableButton = false;

  public form: FormGroup;

  public referringLink;
  public unitId;

  public elementType = NgxQrcodeElementTypes.URL;
  public correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  public value;
  public errorMessage;

  public spinner = false;


  private subscriptions: Subscription[] = [];

  constructor(
    private service: ApiService,
    private ngZone: NgZone,
    private notifierService: NotifierService
  ) {
    this.form = new FormGroup({
      phone: new FormControl('', [Validators.required, Validators.pattern(/^\d{10}$/)]),
      link: new FormControl('')
    });
    branch.init('key_live_fjLv6mgiepqw4mTfvgEBYpihsykGfn7D', {}, (err, data) => this.ngZone.run(() => {
      if (data && data.data_parsed && data.data_parsed['~referring_link']) {
        this.referringLink = data.data_parsed['~referring_link'];
      } else if (data && data.data_parsed && !data.data_parsed['~referring_link']) {
        this.service.getBranchLink('').subscribe((req: any) => {
          if (req && req.url) {
            this.referringLink = req.url;
          }
        });
      }
      if (data && data.data_parsed && data.data_parsed.unitId) {
        this.unitId = data && data.data_parsed && data.data_parsed.unitId;
      }
    }));
  }

  ngOnInit() {
    this.subscriptions.push(
      this.service.getSmsToken().subscribe((response: any) => {
        if (response && response.headers && response.headers.get('sms-token')) {
          this.token = response.headers.get('sms-token');
        }
      })
    );
  }

  public sendNewSMS() {
    if (this.form.valid && !this.disableButton) {
      this.disableButton = true;
      this.subscriptions.push(
        this.referringLink ? this.service.sendSMS({
          phone: `1${this.form.controls.phone.value}`,
          link: this.referringLink
        }, this.token).subscribe(response => {
          if (response) {
            this.modal = true;
          }
        }, error => {
          if (error) {
            if (error.status === 401) {
              this.errorMessage = 'Your session has timed out. Please refresh the page and try again.';
            }
            this.errorModal = true;
          }
        }) : this.service.getBranchLink(this.unitId).subscribe((res: any) => {
          if (res && res.url) {
            this.service.sendSMS({
              phone: `1${this.form.controls.phone.value}`,
              link: res.url
            }, this.token).subscribe(response => {
              if (response) {
                this.modal = true;
              }
            }, error => {
              if (error) {
                if (error.status === 401) {
                  this.errorMessage = 'Your session has timed out. Please refresh the page and try again.';
                }
                this.errorModal = true;
              }
            });
          } else {
            this.errorModal = true;
          }
        })
      );
    } else {
      this.form.markAllAsTouched();
    }
  }

  closeModal() {
    this.modal = false;
    this.disableButton = false;
  }

  closeErrorModal() {
    this.errorModal = false;
    this.disableButton = false;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(e => e.unsubscribe());
    this.token = null;
  }

  public copyLink() {
    this.notifierService.notify('default', 'Link copied');
  }

  public openLink() {
    if (this.referringLink) {
      window.open(this.referringLink, '_blank');
    }
  }
}
